export const version = "random/5.0.5";
//# sourceMappingURL=_version.js.map